import React, { useState } from 'react';
import axios from "axios";
import {
  Input,
  Label,
  Button,
  Form,
  Alert,
  Spinner
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import {
  APIClient,
  setAuthorization,
  saveAuthUser
} from '../../helpers/api_helper';
import logoWhite from '../../assets/images/crm-expert-logo-white.png';
// Add a photo (people collaborating, office, dashboard screenshot, etc.) at this path.
// Any wide (1600px+) landscape image works well here.
import loginBg from '../../assets/images/bg-img-login.jpg';

const api = new APIClient();

const PortalLogin = () => {
  const [emailOrUsername, setEmailOrUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // ---- ORIGINAL LOGIC — UNCHANGED ----
  const handleSubmit = async (e) => {
    e.preventDefault();

    setError(null);
    setLoading(true);

    try {
      const username = (emailOrUsername || "").trim();

      if (!username || !password) {
        setError("Please enter username and password.");
        return;
      }

      delete axios.defaults.headers.common["Authorization"];

      const response = await api.create("/userportal", {
        _operation: "Ping",
        username: username,
        password: password,
      });

      console.log("CRM Login Response:", response);

      if (
        response &&
        response.success === true &&
        response.result &&
        response.result.token
      ) {
        const token = response.result.token;

        const userObj = {
          token: token,
          user: {
            username: username,
            userId: response.result.userId || null,
            roleId: response.result.roleId || null,
          },
        };

        saveAuthUser(userObj);
        setAuthorization(token);

        console.log("CRM login successful");

        navigate("/leads", { replace: true });
      } else {
        setError(
          response?.result?.message ||
          response?.message ||
          "Invalid CRM username or password."
        );
      }

    } catch (err) {
      console.error("CRM Login Error:", err);

      setError(
        typeof err === "string"
          ? err
          : err?.response?.data?.message ||
          err?.message ||
          "Unable to login to CRM."
      );
    } finally {
      setLoading(false);
    }
  };
  // ---- END ORIGINAL LOGIC ----

  return (
    <div className="portal-login-wrapper">
      <style>{`
        .portal-login-wrapper {
          min-height: 100vh;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: #f6f7fb;
          position: relative;
          overflow: hidden;
          font-family: inherit;
        }

        .portal-card-wrap {
          position: relative;
          width: 100%;
          max-width: 420px;
          margin-top: -90px;
          z-index: 2;
        }

        .portal-card-wrap::before {
          content: '';
          position: absolute;
          inset: -14px;
          background: linear-gradient(135deg, #6a5ff0, #a78bfa);
          border-radius: 24px;
          opacity: 0.12;
          filter: blur(6px);
          z-index: -1;
        }

        .portal-hero {
          width: 100%;
          padding: 56px 16px 130px;
          background-image: linear-gradient(135deg, rgba(45, 33, 158, 0.88) 0%, rgba(106, 95, 240, 0.85) 55%, rgba(138, 125, 255, 0.82) 100%), url(${loginBg});
          background-size: cover;
          background-position: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          clip-path: ellipse(85% 100% at 50% 0%);
        }

        .portal-hero-logo {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 6px;
        }

        .portal-hero-logo img {
          height: 100px;
          width: auto;
        }

        .portal-card {
          width: 100%;
          background: #ffffff;
          border-radius: 18px;
          box-shadow: 0 20px 45px rgba(75, 63, 209, 0.18);
          padding: 40px 36px 34px;
          position: relative;
        }

        .portal-card h4 {
          font-weight: 700;
          font-size: 1.5rem;
          color: #2b2560;
          margin-bottom: 4px;
          text-align: center;
        }

        .portal-card p.subtitle {
          text-align: center;
          color: #8b8aa3;
          font-size: 0.92rem;
          margin-bottom: 28px;
        }

        .portal-field-label {
          font-size: 0.85rem;
          font-weight: 600;
          color: #4a4867;
          margin-bottom: 6px;
          display: block;
        }

        .portal-input-group {
          margin-bottom: 20px;
        }

        .portal-input {
          background: #f4f4fb !important;
          border: 1px solid #eceaf7 !important;
          border-radius: 10px !important;
          padding: 12px 14px !important;
          font-size: 0.95rem !important;
          transition: border-color 0.15s ease, box-shadow 0.15s ease;
        }

        .portal-input:focus {
          border-color: #6a5ff0 !important;
          box-shadow: 0 0 0 3px rgba(106, 95, 240, 0.14) !important;
        }

        .portal-password-field {
          position: relative;
        }

        .portal-password-toggle {
          position: absolute;
          right: 14px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          padding: 0;
          color: #9b99b5;
          cursor: pointer;
          font-size: 0.8rem;
          font-weight: 600;
        }

        .portal-row-between {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 22px;
        }

        .portal-remember {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 0.85rem;
          color: #6b6985;
        }

        .portal-remember input {
          width: 15px;
          height: 15px;
          accent-color: #6a5ff0;
          cursor: pointer;
        }

        .portal-forgot {
          font-size: 0.85rem;
          font-weight: 600;
          color: #6a5ff0;
          text-decoration: none;
          background: none;
          border: none;
          cursor: pointer;
        }

        .portal-forgot:hover {
          text-decoration: underline;
        }

        .portal-submit-btn {
          width: 100%;
          border: none;
          border-radius: 10px;
          padding: 12px;
          font-size: 1rem;
          font-weight: 600;
          background: linear-gradient(135deg, #4b3fd1, #6a5ff0);
          box-shadow: 0 10px 20px rgba(106, 95, 240, 0.28);
          transition: transform 0.12s ease, box-shadow 0.12s ease;
        }

        .portal-submit-btn:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 14px 26px rgba(106, 95, 240, 0.34);
        }

        .portal-submit-btn:disabled {
          opacity: 0.75;
        }

        .portal-alert {
          border-radius: 10px;
          font-size: 0.88rem;
          border: none;
          background: #fdeceb;
          color: #c0392b;
        }

        .portal-divider {
          display: flex;
          align-items: center;
          gap: 12px;
          margin: 26px 0 20px;
        }

        .portal-divider::before,
        .portal-divider::after {
          content: '';
          flex: 1;
          height: 1px;
          background: #ecebf5;
        }

        .portal-divider span {
          font-size: 0.78rem;
          color: #a5a3ba;
          white-space: nowrap;
        }

        .portal-social-row {
          display: flex;
          justify-content: center;
          gap: 12px;
        }

        .portal-social-btn {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          border: 1px solid #ecebf5;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: transform 0.12s ease, box-shadow 0.12s ease, border-color 0.12s ease;
          color: #5b5875;
        }

        .portal-social-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(75, 63, 209, 0.14);
          border-color: #d9d6f7;
        }

        .portal-footer-note {
          text-align: center;
          margin-top: 22px;
          font-size: 0.85rem;
          color: #9997ad;
        }

        @media (max-width: 480px) {
          .portal-card {
            padding: 32px 22px 28px;
          }
          .portal-card-wrap {
            margin-top: -70px;
          }
          .portal-hero {
            padding: 44px 16px 110px;
          }
        }
      `}</style>

      <div className="portal-hero">
        <div className="portal-hero-logo">
          <img src={logoWhite} alt="CRM Expert" />
        </div>
      </div>

      <div className="portal-card-wrap">
        <div className="portal-card">
          <h4>Welcome back</h4>
          <p className="subtitle">Sign in to continue to your dashboard.</p>

          {error && (
            <Alert className="portal-alert">
              {error}
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <div className="portal-input-group">
              <Label className="portal-field-label">Username or Email</Label>
              <Input
                type="text"
                value={emailOrUsername}
                onChange={(e) => setEmailOrUsername(e.target.value)}
                placeholder="Enter your username or email"
                className="portal-input"
                disabled={loading}
                autoComplete="username"
              />
            </div>

            <div className="portal-input-group portal-password-field">
              <Label className="portal-field-label">Password</Label>
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="portal-input"
                disabled={loading}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="portal-password-toggle"
                style={{ top: '68%' }}
                onClick={() => setShowPassword((s) => !s)}
                tabIndex={-1}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>

            <div className="portal-row-between">
              <label className="portal-remember">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                Remember me
              </label>

              <button type="button" className="portal-forgot">
                Forgot password?
              </button>
            </div>

            <Button
              color="primary"
              type="submit"
              className="portal-submit-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Signing in...
                </>
              ) : (
                'Sign In'
              )}
            </Button>
          </Form>

          <div className="portal-divider"><span>or continue with</span></div>

          <div className="portal-social-row">
            <button type="button" className="portal-social-btn" aria-label="Continue with Google" title="Continue with Google">
              <svg width="18" height="18" viewBox="0 0 48 48">
                <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.7-.4-3.5z" />
                <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 15.9 18.9 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
                <path fill="#4CAF50" d="M24 44c5.5 0 10.4-1.9 14.3-5.1l-6.6-5.4C29.6 35.4 26.9 36 24 36c-5.3 0-9.7-3.3-11.3-8l-6.6 5.1C9.6 39.6 16.3 44 24 44z" />
                <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.7l6.6 5.4C41.5 35.9 44 30.4 44 24c0-1.3-.1-2.7-.4-3.5z" />
              </svg>
            </button>

            <button type="button" className="portal-social-btn" aria-label="Continue with Facebook" title="Continue with Facebook">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="#1877F2"><path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06C2 17.08 5.66 21.23 10.44 22v-7.03H7.9v-2.9h2.54V9.85c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.23.2 2.23.2v2.45h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.44 2.9h-2.34V22C18.34 21.23 22 17.08 22 12.06z" /></svg>
            </button>

            <button type="button" className="portal-social-btn" aria-label="Continue with GitHub" title="Continue with GitHub">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="#181717"><path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.57.1.78-.25.78-.55v-2.1c-3.2.7-3.87-1.36-3.87-1.36-.53-1.33-1.29-1.69-1.29-1.69-1.05-.72.08-.7.08-.7 1.17.08 1.78 1.2 1.78 1.2 1.03 1.77 2.71 1.26 3.37.96.1-.75.4-1.26.73-1.55-2.55-.29-5.23-1.28-5.23-5.68 0-1.25.45-2.28 1.19-3.08-.12-.29-.52-1.46.11-3.04 0 0 .97-.31 3.18 1.18a11.1 11.1 0 0 1 5.79 0c2.2-1.49 3.17-1.18 3.17-1.18.64 1.58.24 2.75.12 3.04.74.8 1.19 1.83 1.19 3.08 0 4.41-2.69 5.38-5.25 5.67.42.36.78 1.08.78 2.18v3.23c0 .31.21.66.79.55A10.52 10.52 0 0 0 23.5 12C23.5 5.65 18.35.5 12 .5z" /></svg>
            </button>
          </div>

          <p className="portal-footer-note">Secure portal access for CRM Expert users.</p>
        </div>
      </div>
    </div>
  );
};

export default PortalLogin;